var exports = {
  "custom-switcher": "x43cbe9c2--c1e3d7--custom-switcher",
  "custom-switcher-item": "x43cbe9c2--c1e3d7--custom-switcher-item",
  "active": "x43cbe9c2--c1e3d7--active",
  "coin": "x43cbe9c2--c1e3d7--coin",
  "calendar": "x43cbe9c2--c1e3d7--calendar",
  "key": "x43cbe9c2--c1e3d7--key",
  "container": "x43cbe9c2--c1e3d7--container",
  "tablet": "x43cbe9c2--c1e3d7--tablet",
  "phone": "x43cbe9c2--c1e3d7--phone",
  "switchers-body": "x43cbe9c2--c1e3d7--switchers-body",
  "switch": "x43cbe9c2--c1e3d7--switch",
  "switcher-title": "x43cbe9c2--c1e3d7--switcher-title",
  "image": "x43cbe9c2--c1e3d7--image",
  "text": "x43cbe9c2--c1e3d7--text",
  "btn-container": "x43cbe9c2--c1e3d7--btn-container",
};

module.exports = exports;
